import { render, staticRenderFns } from "./HandHoldingHeart.vue?vue&type=template&id=6bd296ee&scoped=true&"
import script from "./HandHoldingHeart.vue?vue&type=script&lang=js&"
export * from "./HandHoldingHeart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd296ee",
  null
  
)

export default component.exports